import type {
  AIAssistantQuestionType,
  AICredits,
  AIAssistantConversationListData,
  AIAssistantSelectedDocument,
} from '@/types/ai-assistant'

export type AIAssistantState = {
  questionType: AIAssistantQuestionType | null
  conversationActiveId: string | null
  conversations: AIAssistantConversationListData
  credits: AICredits | null
  creditsPending: boolean
  getConversationsPending: boolean
  getConversationMessagesPending: boolean
  isPaneOpened: boolean
  isConversationOpen: boolean
  postPromptPending: boolean
  postPromptStreaming: boolean
  pendingConversationId: string | null
  selectedDocuments: AIAssistantSelectedDocument[]
  remainingConversations: number | null
}

export const state: AIAssistantState = {
  questionType: null,
  conversationActiveId: null,
  conversations: {
    yesterday: [],
    today: [],
    lastSevenDays: [],
    lastThirtyDays: [],
    lastNinetyDays: [],
  },
  credits: null,
  creditsPending: false,
  getConversationsPending: false,
  getConversationMessagesPending: false,
  isConversationOpen: true,
  isPaneOpened: false,
  postPromptPending: false,
  postPromptStreaming: false,
  pendingConversationId: null,
  selectedDocuments: [],
  remainingConversations: null,
}
